import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { getLoadMoreLimit } from 'reactApp/modules/storage/storage.helpers';
import { filterIdsByAuthors, getHomeStorageItemIds, getStorageSelectedItems } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { trashbinRestoreAllRequest, trashbinRestoreRequest } from 'reactApp/modules/trashbin/trashbin.module';
import { store as reduxStore } from 'reactApp/store';

import { seriallyClearBinFeature } from '../featuresHelpers/features/seriallyClearBin';

interface RestoreParams {
    id?: string;
    source?: string;
}

export const restore = (params: RestoreParams = {}): void => {
    const { id, source } = params;
    const state = reduxStore.getState();
    const ids = id ? [id] : SelectionsSelectors.getSelectedIdxs(state);
    const storage = getCurrentStorage(state);
    const LOAD_LIMIT = getLoadMoreLimit(EStorageType.trashbin);
    const allIds = getHomeStorageItemIds(state, storage);
    const allIdxs = filterIdsByAuthors(state, allIds, storage);
    const allSelectedIdx = getStorageSelectedItems(state, storage);
    const allSelected = allIdxs?.length && allIdxs?.length === allSelectedIdx?.length;
    if (seriallyClearBinFeature && allSelected && ids?.length && (ids.length > LOAD_LIMIT || state?.trashbin?.bins?.[0]?.hasMoreToLoad)) {
        reduxStore.dispatch(trashbinRestoreAllRequest());
    } else {
        reduxStore.dispatch(trashbinRestoreRequest({ ids, from: source || 'toolbar' }));
    }
};
